import React, {useEffect, useState} from 'react'

function getAlter(zuletzt, jetzt) {
    const sekunden = Math.max(0, Math.round((jetzt - zuletzt) / 1000));
    if (sekunden < 10) {
        return "gerade eben";
    }
    if (sekunden < 60) {
        return "vor " + sekunden + " Sek.";
    }
    return "vor " + Math.floor(sekunden / 60) + " Min.";
}

/**
 * Zeigt, wann zuletzt aktualisiert wurde, und ob noch automatisch geladen wird (siehe useAutoAktualisierung).
 */
export default function AktualisierungsHinweis({aktualisierung}) {

    const [jetzt, setJetzt] = useState(Date.now());

    // nur für die Altersangabe, geladen wird im Hook
    useEffect(() => {
        const timer = setInterval(() => setJetzt(Date.now()), 5000);
        return () => clearInterval(timer);
    }, []);

    const {aktiv, zuletzt, jetztLaden, wiederEinschalten} = aktualisierung;
    const alter = zuletzt === undefined ? "" : " · aktualisiert " + getAlter(zuletzt, Math.max(jetzt, zuletzt));

    return <div className={aktiv ? "dhte-aktualisierung" : "dhte-aktualisierung dhte-aktualisierung-aus"}>
        <i className={aktiv ? "pi pi-sync" : "pi pi-pause-circle"} aria-hidden="true"/>
        <span>{aktiv ? "Wird automatisch aktualisiert" : "Automatische Aktualisierung nach 1 Std. beendet"}{alter}</span>
        <button type="button" className="dhpt-text-knopf dhte-aktualisierung-knopf" onClick={aktiv ? jetztLaden : wiederEinschalten}>
            {aktiv ? "Jetzt aktualisieren" : "Wieder einschalten"}
        </button>
    </div>
}
